import React from 'react';
import { ParticipantHubLayout } from './ParticipantHubLayout';
import { motion } from 'framer-motion';
import { SearchIcon, FilterIcon, ClockIcon, BookmarkIcon, SparklesIcon } from 'lucide-react';
export function KnowledgeStudioPage() {
  const categories = ['All', 'Frameworks', 'Case Studies', 'Worksheets', 'Videos'];
  const library = [{
    title: 'The 5 Dysfunctions of a Team',
    type: 'Framework',
    time: '15 min read',
    image: 'https://images.unsplash.com/photo-1552664730-d307ca884978?auto=format&fit=crop&w=800&q=80',
    recommended: true
  }, {
    title: 'Finova Capital: 2025 Strategy Deck',
    type: 'Case Study',
    time: '20 min read',
    image: 'https://images.unsplash.com/photo-1460925895917-afdab827c52f?auto=format&fit=crop&w=800&q=80',
    recommended: true
  }, {
    title: 'AI Readiness Assessment',
    type: 'Worksheet',
    time: '10 min exercise',
    image: 'https://images.unsplash.com/photo-1454165804606-c3d57bc86b40?auto=format&fit=crop&w=800&q=80',
    recommended: true
  }, {
    title: 'Leading Through Change',
    type: 'Video',
    time: '45 min watch',
    image: 'https://images.unsplash.com/photo-1557804506-669a67965ba0?auto=format&fit=crop&w=800&q=80',
    recommended: false
  }, {
    title: 'Customer Journey Mapping',
    type: 'Framework',
    time: '12 min read',
    image: 'https://images.unsplash.com/photo-1531403009284-440f080d1e12?auto=format&fit=crop&w=800&q=80',
    recommended: false
  }, {
    title: 'Q3 Post-Mortem Analysis',
    type: 'Case Study',
    time: '18 min read',
    image: 'https://images.unsplash.com/photo-1507679799987-c73779587ccf?auto=format&fit=crop&w=800&q=80',
    recommended: false
  }];
  return <ParticipantHubLayout data-id="element-4719">
      <div className="p-6 lg:p-8 max-w-7xl mx-auto space-y-8" data-id="element-4720">
        {/* Header & Search */}
        <div className="flex flex-col md:flex-row md:items-end justify-between gap-6" data-id="element-4721">
          <div data-id="element-4722">
            <h1 className="font-serif-display text-4xl text-slate-900 mb-2" data-id="element-4723">
              Knowledge Studio
            </h1>
            <p className="text-slate-500" data-id="element-4724">
              Curated frameworks, insights, and resources for your summit.
            </p>
          </div>
          <div className="flex items-center gap-3 w-full md:w-auto" data-id="element-4725">
            <div className="relative flex-1 md:w-64" data-id="element-4726">
              <SearchIcon className="absolute left-3 top-1/2 -translate-y-1/2 w-4 h-4 text-slate-400" data-id="element-4727" />
              <input type="text" placeholder="Search resources..." className="w-full pl-9 pr-4 py-2 bg-white border border-slate-200 rounded-xl text-sm focus:ring-2 focus:ring-amber-500/20 focus:border-amber-500 outline-none transition-all" data-id="element-4728" />
            </div>
            <button className="p-2 bg-white border border-slate-200 rounded-xl text-slate-500 hover:bg-slate-50 transition-colors" data-id="element-4729">
              <FilterIcon className="w-5 h-5" data-id="element-4730" />
            </button>
          </div>
        </div>

        {/* Categories */}
        <div className="flex items-center gap-2 overflow-x-auto pb-2 scrollbar-hide" data-id="element-4731">
          {categories.map((cat, i) => <button key={cat} className={`px-4 py-1.5 rounded-full text-sm font-medium whitespace-nowrap transition-colors ${i === 0 ? 'bg-[#0B1B3B] text-white' : 'bg-white border border-slate-200 text-slate-600 hover:bg-slate-50'}`} data-id="element-4732">
              {cat}
            </button>)}
        </div>

        {/* Recommended Section */}
        <div data-id="element-4733">
          <div className="flex items-center gap-2 mb-6" data-id="element-4734">
            <SparklesIcon className="w-5 h-5 text-amber-500" data-id="element-4735" />
            <h2 className="font-serif-display text-2xl text-slate-900" data-id="element-4736">
              Recommended for Sarah
            </h2>
          </div>
          <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-6" data-id="element-4737">
            {library.filter(item => item.recommended).map((item, i) => <motion.div key={i} initial={{
            opacity: 0,
            y: 20
          }} animate={{
            opacity: 1,
            y: 0
          }} transition={{
            delay: i * 0.1
          }} className="bg-white rounded-2xl border border-slate-200 overflow-hidden shadow-sm group cursor-pointer hover:shadow-md transition-all" data-id="element-4738">
                  <div className="h-48 overflow-hidden relative" data-id="element-4739">
                    <img src={item.image} alt={item.title} className="w-full h-full object-cover group-hover:scale-105 transition-transform duration-500" data-id="element-4740" />
                    <div className="absolute top-3 right-3 w-8 h-8 bg-white/90 backdrop-blur-sm rounded-full flex items-center justify-center text-slate-400 hover:text-amber-500 transition-colors" data-id="element-4741">
                      <BookmarkIcon className="w-4 h-4" data-id="element-4742" />
                    </div>
                  </div>
                  <div className="p-5" data-id="element-4743">
                    <div className="text-xs font-bold text-amber-600 uppercase tracking-wider mb-2" data-id="element-4744">
                      {item.type}
                    </div>
                    <h3 className="font-bold text-lg text-slate-900 mb-3 line-clamp-2" data-id="element-4745">
                      {item.title}
                    </h3>
                    <div className="flex items-center gap-2 text-sm text-slate-500" data-id="element-4746">
                      <ClockIcon className="w-4 h-4" data-id="element-4747" />
                      {item.time}
                    </div>
                  </div>
                </motion.div>)}
          </div>
        </div>

        {/* All Resources */}
        <div data-id="element-4748">
          <h2 className="font-serif-display text-2xl text-slate-900 mb-6" data-id="element-4749">
            Recently Added
          </h2>
          <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-6" data-id="element-4750">
            {library.filter(item => !item.recommended).map((item, i) => <motion.div key={i} initial={{
            opacity: 0,
            y: 20
          }} animate={{
            opacity: 1,
            y: 0
          }} transition={{
            delay: 0.3 + i * 0.1
          }} className="bg-white rounded-2xl border border-slate-200 overflow-hidden shadow-sm group cursor-pointer hover:shadow-md transition-all" data-id="element-4751">
                  <div className="h-48 overflow-hidden relative" data-id="element-4752">
                    <img src={item.image} alt={item.title} className="w-full h-full object-cover group-hover:scale-105 transition-transform duration-500" data-id="element-4753" />
                    <div className="absolute top-3 right-3 w-8 h-8 bg-white/90 backdrop-blur-sm rounded-full flex items-center justify-center text-slate-400 hover:text-amber-500 transition-colors" data-id="element-4754">
                      <BookmarkIcon className="w-4 h-4" data-id="element-4755" />
                    </div>
                  </div>
                  <div className="p-5" data-id="element-4756">
                    <div className="text-xs font-bold text-slate-500 uppercase tracking-wider mb-2" data-id="element-4757">
                      {item.type}
                    </div>
                    <h3 className="font-bold text-lg text-slate-900 mb-3 line-clamp-2" data-id="element-4758">
                      {item.title}
                    </h3>
                    <div className="flex items-center gap-2 text-sm text-slate-500" data-id="element-4759">
                      <ClockIcon className="w-4 h-4" data-id="element-4760" />
                      {item.time}
                    </div>
                  </div>
                </motion.div>)}
          </div>
        </div>
      </div>
    </ParticipantHubLayout>;
}